<script>
import {ref, watch} from "vue";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import $ from "jquery";

export default {
  name: "AddProducts",
  components: {LoadingPage},
  setup() {

    let loading = ref(false)
    let dialog = ref(false)

    let action = ref(useRoute().params.action)

    let price_off = ref('')
    let data_prod = ref({
      pid: null,
      price: '',
      price_panel: '',
      local: 0,
      factor: false,
    })

    let guilds = ref({
      all: [],
      select: null,
    })
    let one_category = ref({
      all: [],
      select: null,
    })
    let two_category = ref({
      all: [],
      select: null,
    })
    let products = ref({
      all: [],
      select: null,
      unit: null,
      brand: null,
      name: null,
    })

    let search_product = ref([])
    let input_search = ref()

    watch(()=> input_search.value , ()=>{
    search_products()
    })

    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'all_guild'}, 'info').then((res) => {

        loading.value = false
        guilds.value.all = res.data
        guilds.value.select = res.data[0].id

        try {
          if (action.value === 'new') {
            if (guilds.value.all[0]) {
              one_category.value.all = guilds.value.all[0].category
              if (one_category.value.all[0]) {
                one_category.value.select = one_category.value.all[0].id
                two_category.value.all = one_category.value.all[0].subcategory
                if (two_category.value.all[0]) {
                  two_category.value.select = two_category.value.all[0].id
                  products.value.all = two_category.value.all[0].products
                  search_product.value = two_category.value.all[0].products
                  if (products.value.all[0]) {
                    products.value.select = products.value.all[0].id
                    products.value.brand = products.value.all[0].brand
                    products.value.unit = products.value.all[0].unit
                    products.value.name = products.value.all[0].name
                  } else {
                    products.value.select = null
                    products.value.brand = null
                    products.value.unit = null
                    products.value.name = null
                  }
                }
              }
            }
          }else {
            edit_prod()
          }
        }
        catch (e) {
          console.log(e.message)
        }


      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()

    function search_products() {
      products.value.all = []
      search_product.value.forEach((item)=>{
        if (item.name.includes(input_search.value)) products.value.all.push(item)
      })
    }

    function open_dialog() {
      let div_dialog = $('#dialog')

      if (dialog.value) {
        div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        setTimeout(() => {
          dialog.value = false
        }, 700)
      } else {
        div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        dialog.value = true
      }
    }

    function edit_prod() {

      loading.value = true
      FreeWorld.Heisenberg({pid:action.value} , 'product' , true).then((res)=>{

        loading.value = false
        products.value.select = res.data.id
        two_category.value.select = res.data.subcategory_id
        one_category.value.select = res.data.category_id
        guilds.value.select = res.data.guild_id
        data_prod.value.local = res.data.shopinfo.local
        data_prod.value.price = res.data.shopinfo.price
        data_prod.value.price_panel = res.data.shopinfo.price_panel
        if (res.data.shopinfo.factor === 1) data_prod.value.factor = true
        if (res.data.shopinfo.price !== res.data.shopinfo.price_off) price_off.value = res.data.shopinfo.price_off
        chang_category('edit')

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , edit_prod)
      })

    }

    function chang_category(type) {

      switch (type) {
        case 'guild' :
          guilds.value.all.forEach((item) => {
            if (item.id === guilds.value.select) {
              one_category.value.all = item.category
              if (one_category.value.all[0]) {
                one_category.value.select = one_category.value.all[0].id
                two_category.value.all = one_category.value.all[0].subcategory
                if (two_category.value.all[0]) {
                  two_category.value.select = two_category.value.all[0].id
                  products.value.all = two_category.value.all[0].products
                  search_product.value = two_category.value.all[0].products
                  if (products.value.all[0]) {
                    products.value.select = products.value.all[0].id
                    products.value.brand = products.value.all[0].brand
                    products.value.unit = products.value.all[0].unit
                    products.value.name = products.value.all[0].name
                  } else {
                    products.value.select = null
                    products.value.brand = null
                    products.value.unit = null
                    products.value.name = null
                  }

                }else {
                  two_category.value.all = []
                  two_category.value.select = null
                  products.value.all = []
                  search_product.value = []
                  products.value.select = null
                  products.value.brand = null
                  products.value.unit = null
                  products.value.name = null
                }

              }else{
                one_category.value.select = null
                two_category.value.all = []
                two_category.value.select = null
                products.value.all = []
                search_product.value = []
                products.value.select = null
                products.value.brand = null
                products.value.unit = null
              }
            }
          })
          break;

        case 'one_cat' :
          one_category.value.all.forEach((item) => {
            if (item.id === one_category.value.select) {
              two_category.value.all = item.subcategory
              if (two_category.value.all[0]) {
                two_category.value.select = two_category.value.all[0].id
                products.value.all = two_category.value.all[0].products
                search_product.value = two_category.value.all[0].products
                if (products.value.all[0]) {
                  products.value.select = products.value.all[0].id
                  products.value.brand = products.value.all[0].brand
                  products.value.unit = products.value.all[0].unit
                  products.value.name = products.value.all[0].name
                } else {
                  products.value.select = null
                  products.value.brand = null
                  products.value.unit = null
                  products.value.name = null
                }
              }else {
                two_category.value.select = null
                products.value.all = []
                search_product.value = []
                products.value.select = null
                products.value.brand = null
                products.value.unit = null
                products.value.name = null
              }
            }
          })
          break;

        case 'two_cat' :
          two_category.value.all.forEach((item) => {
            if (item.id === two_category.value.select) {
              products.value.all = item.products
              search_product.value = item.products
              if (products.value.all[0]) {
                products.value.select = products.value.all[0].id
                products.value.brand = products.value.all[0].brand
                products.value.unit = products.value.all[0].unit
                products.value.name = products.value.all[0].name
              } else {
                products.value.select = null
                products.value.brand = null
                products.value.unit = null
                products.value.name = null
              }
            }
          })
          break;

        case 'product' :
          products.value.all.forEach((item) => {
            if (item.id === products.value.select) {
              products.value.unit = item.unit
              products.value.brand = item.brand
              products.value.name = item.name
              open_dialog()
              return false
            }
          })
          break;

        case 'edit' :
              guilds.value.all.forEach((item)=>{
                if (item.id == guilds.value.select){
                  one_category.value.all = item.category
                  item.category.forEach((item_cat)=>{
                    if (item_cat.id == one_category.value.select){
                      two_category.value.all = item_cat.subcategory
                      item_cat.subcategory.forEach((item_sub_cat)=>{
                        if (item_sub_cat.id == two_category.value.select){
                          products.value.all = item_sub_cat.products
                          search_product.value = item_sub_cat.products
                          item_sub_cat.products.forEach((item_prod)=>{
                            if (item_prod.id == products.value.select){
                              products.value.brand = item_prod.brand
                              products.value.unit = item_prod.unit
                              products.value.name = item_prod.name
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
              break;

      }

    }

    function add_product() {

      if (products.value.select === null){Swals.Warning('لطفا محصول مورد نظر خود را انتخاب کنید!');return false}
      if (data_prod.value.price.length === 0){Swals.Warning('لطفا قیمت محصول خود را وارد کنید!');return false}

      price_off.value.length === 0 ? data_prod.value.price_off = data_prod.value.price : data_prod.value.price_off = price_off.value
      data_prod.value.pid = products.value.select

      let url = 'shop/add_product'
      if (action.value !== 'new') url = 'shop/product_edit'

      loading.value = true
      FreeWorld.Heisenberg(data_prod.value , url , true).then((res)=>{

        if (data_prod.value.price === data_prod.value.price_off) data_prod.value.price_off = ''
        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('محصول شما با موفقیت ثبت شد' , 'ProductsManagement')
        }else if (res.data.event === 'this product is available for you'){
          Swals.Warning('شما قبلا این محصول را اضافه کرده اید!' , 'ProductsManagement')
        }else {
          Swals.Fault('متاسفانه محصول شما ثبت نشد!')
        }


      }).catch((res)=>{
        if (data_prod.value.price === data_prod.value.price_off) data_prod.value.price_off = ''
        loading.value = false
        Swals.Catch(res , add_product)
      })

    }


    return {

      loading,
      guilds,
      one_category,
      two_category,
      products,
      chang_category,
      data_prod,
      add_product,
      price_off,
      action,
      dialog,
      open_dialog,
      input_search,
      search_products,
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div v-if="dialog" @click="open_dialog" class="bg_dialog"></div>
    <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
      <div class="rounded-4 bg-white p-3">
        <div class="position-relative">
          <p class="font-4 text-color font-bold text-center">انتخاب محصول</p>
          <img @click="open_dialog" class="icon-size-3 position-absolute top-0 start-0" src="../assets/img/close_color.svg" alt="">
        </div>

        <hr>

        <input v-model="input_search" @keydown.enter="search_products" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-4 text-center" placeholder="جستجوی محصول" type="search">

        <p v-if="products.all.length === 0" class="text-red font-4 text-center">آیتمی برای نمایش وجود ندارد</p>

        <div v-else style="max-height: 30rem" class="w-100 bg-custom overflow-y-scroll">
          <div v-for="item in products.all" :key="item.id" class="">
            <p @click="products.select = item.id ; chang_category('product')" class="p-2 font-5 text-center">{{ item.name }}</p>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p v-if="action === 'new'" class="font-color font-4 font-bold">افزودن محصول</p>
        <p v-else class="font-color font-4 font-bold">ویرایش محصول</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body w-100 ">
      <div class="mt-3">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب صنف</p>
        <select v-model="guilds.select" :disabled="action !== 'new'" @change="chang_category('guild')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in guilds.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب سطح اول دسته بندی محصول</p>
        <select v-model="one_category.select" :disabled="action !== 'new'" @change="chang_category('one_cat')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in one_category.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>
      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب سطح دوم دسته بندی محصول</p>
        <select v-model="two_category.select" :disabled="action !== 'new'" @change="chang_category('two_cat')"
                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">
          <option v-for="item in two_category.all" :key="item.id" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب محصول</p>
<!--        <select v-model="products.select" :disabled="action !== 'new'" @change="chang_category('product')"-->
<!--                class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">-->
<!--          <option v-for="item in products.all" :key="item.id" :value="item.id">{{ item.name }}</option>-->
<!--        </select>-->
        <p v-if="products.select === null" @click="open_dialog" class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">محصولی انتخاب نشده</p>
        <p v-else-if="products.select !== null && action === 'new'" @click="open_dialog" class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">{{ products.name }}</p>
        <p v-else class="text-center font-4 bg-white w-100 shadow-custom py-3 px-1 rounded-4">{{ products.name }}</p>
      </div>

      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">واحد محصول</p>

        <div class="shadow-custom bg-white font-5 rounded-4 w-100 py-3 px-2 text-center">
          <p v-if="products.unit !== null" class="animate__animated animate__fadeIn">{{ products.unit }}</p>
          <p v-else class="animate__animated animate__fadeIn">محصول مورد نظر را انتخاب کنید</p>
        </div>
      </div>
      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">انتخاب برند محصول</p>

        <div class="shadow-custom bg-white font-5 rounded-4 w-100 py-3 px-2 text-center">
          <p v-if="products.brand !== null" class="animate__animated animate__fadeIn">{{ products.brand }}</p>
          <p v-else class="animate__animated animate__fadeIn">محصول مورد نظر را انتخاب کنید</p>
        </div>
      </div>
      <div class="mt-4">
        <p class="m-0 me-2 mb-2 font-4 font-bold font-color">فروش این محصول منحصر استان شماست؟</p>
        <select v-model="data_prod.local" :disabled="action !== 'new'" class="text-center bg-white font-4 w-100 shadow-custom py-3 px-1 rounded-4">
          <option :value="0">خیر</option>
          <option :value="1">بله</option>
        </select>
      </div>
      <div class="p-body py-3 bg-white rounded-4 shadow-custom mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <img src="../assets/img/redinfo.png" style="width: 40px;height: 40px">
          <p class="m-0 me-1 font-color-red font-bold font-4">باکس قیمت برای کاربر معمولی</p>
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center justify-space-between me-2 mb-2">
            <div class="d-flex align-items-center">
              <p class="font-4 font-bold font-color">قیمت بدون تخفیف محصول (تومان)</p>
              <img v-if="action !== 'new'" class="mr-2" style="width: 20px" src="../assets/img/pencil_color_light.svg" alt="">
            </div>

            <p v-if="data_prod.price > 0" class="d-flex align-items-center justify-content-end font-color-green overflow-hidden" :class="action !== 'new' ? 'w-20':'w-25'">
              <span class="font-5 font-bold">{{ parseInt(data_prod.price).toLocaleString() }}</span>
            </p>
          </div>
          <input v-model="data_prod.price" onkeydown="return event.key !== ' '" class="shadow-custom bg-main font-5 rounded-4 w-100 py-3 px-2 text-center" type="tel">
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center justify-space-between me-2 mb-2">
            <div class="d-flex align-items-center">
              <p class="font-4 font-bold font-color">قیمت با تخفیف محصول (تومان)</p>
              <img v-if="action !== 'new'" class="mr-2" style="width: 20px" src="../assets/img/pencil_color_light.svg" alt="">
            </div>

            <p v-if="price_off > 0" class="d-flex align-items-center justify-content-end font-color-green overflow-hidden" :class="action !== 'new' ? 'w-20':'w-25'">
              <span class="font-5 font-bold">{{ parseInt(price_off).toLocaleString() }}</span>
            </p>
          </div>
          <input v-model="price_off" onkeydown="return event.key !== ' '" class="shadow-custom bg-main font-5 rounded-4 w-100 py-3 px-2 text-center" type="tel" placeholder="در صورت خالی بودن قیمت تخفیف خورده درج نمیشود">
        </div>

        <div class="d-flex justify-content-start align-items-center mt-3">
          <input v-model="data_prod.factor" id="factor" type="checkbox">
          <label for="factor" class="m-0 mr-1 font-color font-4">فروش محصول به صورت رسمی</label>
          <img v-if="action !== 'new'" class="mr-2" style="width: 20px" src="../assets/img/pencil_color_light.svg" alt="">
        </div>
        <p class="m-0 mt-2 me-2 font-6 text-dark">با زدن این تیک، محصول فقط به صورت رسمی فاکتور میشود</p>
      </div>
      <div class="p-body py-3 bg-white rounded-4 shadow-custom mt-4">
        <div class="d-flex justify-content-start align-items-center">
          <img src="../assets/img/redinfo.png" style="width: 40px;height: 40px">
          <p class="m-0 me-1 font-color-red font-bold font-4">باکس قیمت برای کاربر ویژه (همکار)</p>
        </div>
        <p class="m-0 mt-2 me-2 font-6 text-dark">کاربران ویژه به بازاریابانی گفته میشود که
          میتواندد در فروش محصولات شما همکاری کنند</p>

        <div class="mt-4">
          <div class="d-flex align-items-center justify-space-between me-2 mb-2">
            <div class="d-flex align-items-center">
              <p class="font-4 font-bold font-color">قیمت محصول (تومان)</p>
              <img v-if="action !== 'new'" class="mr-2" style="width: 20px" src="../assets/img/pencil_color_light.svg" alt="">
            </div>

            <p v-if="data_prod.price_panel > 0" class="d-flex align-items-center justify-content-end font-color-green overflow-hidden" :class="action !== 'new' ? 'w-40':'w-50'">
              <span class="font-5 font-bold">{{ parseInt(data_prod.price_panel).toLocaleString() }}</span>
            </p>
          </div>
          <input v-model="data_prod.price_panel" onkeydown="return event.key !== ' '"
                 class="shadow-custom bg-main font-4 rounded-4 border-0 w-100 py-3 px-2 text-center" type="tel">
        </div>

      </div>
      <v-btn @click="add_product" class="py-3 h-100 my-4 w-100 border-0 rounded-3 bg-color text-white">ثبت نهایی</v-btn>

    </div>


  </div>

</template>


<style scoped>

</style>